import React from "react";
import { Field } from "redux-form";
import { DateRenderer } from "src/shared/forms/formrenderers/DateRenderer";
import type { DateInputProps } from "src/shared/forms/inputs/DateInputNew";

export const DateInput = ({ inputID, label, ...rest }: DateInputProps) => {
  return (
    <Field
      name={inputID}
      label={label}
      type="date-local"
      component={DateRenderer}
      {...rest}
    />
  );
};
